export function getImagePath(record: { collectionId: string, id: string, src: string, direct?: boolean }) {
  const { backendUrl } = useRuntimeConfig().public
  const { collectionId, id, src } = record
  const path = `${collectionId}/${id}/${src}`
  // if (!record.direct)
  //   return `mctweb/${path}`
  return `${backendUrl}/api/files/${path}`
}

export function getBusinessStatus(business: Business | BusinessWithCategories | BusinessWithStatus) {
  if (business.hidden) {
    return 'Hidden'
  }
  if (!business.verified) {
    return 'Not Verified'
  }
  if (!business.liveUntil) {
    return 'Requires Action'
  }
  if (new Date(business.liveUntil) < new Date()) {
    return 'Expired'
  }
  return 'Live'
}

export function transformBusinesses(businesses: Business[]) {
  const businessItems = businesses.map((business: Business): BusinessWithStatus => {
    return { ...business, status: getBusinessStatus(business) }
  })
  return businessItems
}

export function transformSubscriptions(subscriptions: Subscription[], businesses: Business[]) {
  return subscriptions.map((subscription: Subscription) => {
    return { ...subscription, product: subscription?.expand?.product, expand: { business: businesses?.find(x => x.id === subscription.business) } }
  })
}

export function transformSubscription(subscription: Subscription) {
  return { ...subscription, status: getStatusData(subscription.status) }
}

export function getStatusData(status: SubscriptionStatus) {
  switch (status) {
    case 'incomplete':
      return { label: 'Incomplete', color: 'bg-orange-600' }
    case 'incomplete_expired':
      return { label: 'Expired', color: 'bg-red-500' }
    case 'trialing':
      return { label: 'Subscription Ready', color: ' bg-blue-600' }
    case 'active':
      return { label: 'Active', color: 'bg-primary-500' }
    case 'past_due':
      return { label: 'Past Due', color: 'bg-red-600' }
    case 'canceled':
      return { label: 'Cancelled', color: 'bg-red-700 text-white' }
    case 'unpaid':
      return { label: 'Unpaid', color: 'bg-red-800' }
    case 'paused':
      return { label: 'Paused', color: 'bg-orange-500' }
    default:
      return { label: '', color: '' }
  }
}
